import { useParams } from 'react-router-dom'
import { TableView } from '../features/customer/screens/TableView'

/**
 * Mesa-based table entry
 * QR → mesaId → backend resolves → POS ticket
 * 
 * This is the correct resolution path for production
 */
export function MesaTableEntry() {
  const { mesaId } = useParams<{ mesaId: string }>()

  if (!mesaId) return <div>Mesa inválida</div>

  return <TableView mesaId={mesaId} />
}
